(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[241],{

/***/ 9254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes",
      function () {
        return __webpack_require__(8294);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8287);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3376);






function Pagination(param) {
    let { pageCount , filters , link  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { page: pageIndex  } = router.query;
    const pageCountArray = [];
    for(let i = 0; i < pageCount; i++){
        pageCountArray.push(i + 1);
    }
    const firstPage = pageCountArray[0];
    const totalPages = pageCountArray[pageCountArray.length - 1];
    const currentPageIndex = Number(pageIndex);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pagination_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(link, "?page=").concat(currentPageIndex - 1).concat(filters ? "&".concat(filters) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_5__/* .ArrowLeft */ .Xd, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("button.pagination.previous")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                children: [
                    currentPageIndex > firstPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === firstPage ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(firstPage).concat(filters ? "&".concat(filters) : ""),
                            children: firstPage
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex
                        })
                    }),
                    totalPages >= 2 && currentPageIndex < totalPages && currentPageIndex + 1 !== totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "current-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex + 1).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex + 1
                        })
                    }) : null,
                    totalPages >= 3 && currentPageIndex <= totalPages && currentPageIndex + 2 !== totalPages && currentPageIndex + 2 < totalPages && currentPageIndex + 1 !== totalPages && currentPageIndex + 2 < totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "current-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(currentPageIndex + 2).concat(filters ? "&".concat(filters) : ""),
                            children: currentPageIndex + 2
                        })
                    }) : null,
                    currentPageIndex !== totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        "aria-label": "total-pages",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            style: parseInt(currentPageIndex) === pageIndex ? {
                                backgroundColor: "#164230",
                                color: "#FFFFFF"
                            } : {
                                backgroundColor: "#f6faf7",
                                color: "#164230"
                            },
                            className: "pagination_link",
                            href: "".concat(link, "?page=").concat(totalPages).concat(filters ? "&".concat(filters) : ""),
                            children: totalPages
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "".concat(link, "?page=").concat(currentPageIndex + 1).concat(filters ? "&".concat(filters) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: t("button.pagination.next")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_5__/* .ArrowRight */ .ol, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RefreshedFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7421);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3376);



function RefreshedFooter(param) {
    let { links , locale  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const lang = locale || "fr";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "footer_title",
                children: t("footer.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle facebook",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoFacebook */ .To, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoInstagram */ .yR, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoLinkedin */ .f8, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "footer_links",
                children: links.map((l, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_third_row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "footer_company_info",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    "Bene Bono\xae ",
                                    new Date().getFullYear()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.privacynotice")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.conditionsofuse")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.legal_mentions")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: t("footer.cookies")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_logo",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .LogoFooter */ .vP, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "footer_address",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "addresses",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.email")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.openhour")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.phonenumber")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.address")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "certification",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification.code")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 8294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Recipes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 19 modules
var esm = __webpack_require__(8287);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Nav/Nav.js
var Nav = __webpack_require__(4193);
// EXTERNAL MODULE: ./components/Pagination/Pagination.js
var Pagination = __webpack_require__(4554);
;// CONCATENATED MODULE: ./components/Recipe/Recipe.js


function Recipe(param) {
    let { imageUrl , tags , title , difficulty , duration  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "recipe",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: tags.map((t)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t.attributes.name
                        }, t.attributes.name))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    difficulty,
                    " \xb7 ",
                    duration
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./assets/index.js + 29 modules
var assets = __webpack_require__(3376);
// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(905);
;// CONCATENATED MODULE: ./components/RecipeSearchBar/RecipeSearchBar.js





function RecipeSearchBar(param) {
    let { setSearchTerm , seasonTags , setSeasonFilter , totalFilter , dietTags , setDietFilter , showFilters , setShowFilters , dietFilter  } = param;
    const setInput = (0,helpers/* debounce */.Ds)((value)=>{
        setSearchTerm(value);
    }, 800);
    const debouceRequest = (0,react.useCallback)((value)=>setInput(value), [
        setInput
    ]);
    const [seasonChecked, setSeasonChecked] = (0,react.useState)("");
    const [dietChecked, setDietChecked] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)();
    const onChangeSeason = (value)=>{
        setSeasonChecked(value);
    };
    const onChangeDiet = (value)=>{
        setDietChecked(value);
    };
    const handleFilters = ()=>{
        setShowFilters((prevState)=>!prevState);
    };
    const handleChange = (e)=>{
        debouceRequest(e.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "search_container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filters_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: handleFilters,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* Filter */.wn, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("filter.title")
                            }),
                            totalFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "total_filter",
                                children: totalFilter
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "icon",
                        onClick: handleFilters,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* ArrowDown */.K5, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: showFilters ? "filters" : "filters-hide",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "filters_title",
                                children: "Filtrer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: handleFilters,
                                className: "cross_icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* Cross */.X1, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "season_filters",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tags_container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: t("season.tag.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: seasonTags.data.map((f)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        onClick: ()=>{
                                                            setSeasonFilter(f.attributes.name);
                                                            onChangeSeason(f.attributes.name);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                name: "filters",
                                                                onChange: ()=>{
                                                                    setSeasonFilter(f.attributes.name);
                                                                    onChangeSeason(f.attributes.name);
                                                                },
                                                                checked: seasonChecked === f.attributes.name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: f.attributes.name
                                                            })
                                                        ]
                                                    }, f.attributes.name);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tags_container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                children: t("diet.tag.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: dietTags.data.map((f)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        onClick: ()=>{
                                                            setDietFilter((prev)=>[
                                                                    ...prev,
                                                                    f.attributes.name
                                                                ]);
                                                            onChangeDiet(f.attributes.name);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                name: "filters",
                                                                checked: dietFilter === null || dietFilter === void 0 ? void 0 : dietFilter.includes(f.attributes.name)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: f.attributes.name
                                                            })
                                                        ]
                                                    }, f.attributes.name);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "button_container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "reset_button",
                                        onClick: ()=>{
                                            setSeasonFilter(undefined), setDietChecked(undefined), setSeasonChecked(undefined);
                                            setDietFilter(undefined);
                                            setShowFilters((prev)=>!prev);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* RefreshArrow */.Xj, {}),
                                            t("filter.button.reset")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "apply_button",
                                        onClick: handleFilters,
                                        children: t("filter.button.apply")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search_bar_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* Search */.HN, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        placeholder: t("search.placeholder"),
                        type: "search",
                        onChange: handleChange
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/RefreshedFooter/RefreshedFooter.js
var RefreshedFooter = __webpack_require__(1216);
;// CONCATENATED MODULE: ./pages/recipes/index.js












var __N_SSP = true;
function Recipes(param) {
    let { recipes , seasonTags , dietTags , navigation , footer  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const [seasonFilter, setSeasonFilter] = (0,react.useState)("");
    const [dietFilter, setDietFilter] = (0,react.useState)([]);
    const [showFilters, setShowFilters] = (0,react.useState)(false);
    const [locale, setLocale] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const dietParams = dietFilter === null || dietFilter === void 0 ? void 0 : dietFilter.map((d)=>d);
    (0,react.useEffect)(()=>{
        router.push({
            pathname: "/recipes",
            query: {
                page: router.query.page && !searchTerm ? router.query.page : 1,
                search: searchTerm ? searchTerm : [],
                seasonFilter: seasonFilter ? seasonFilter : [],
                dietFilter: dietParams ? dietParams : []
            }
        });
    }, [
        searchTerm,
        seasonFilter,
        dietFilter
    ]);
    (0,react.useEffect)(()=>{
        var _window_rudderanalytics;
        window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.page();
    }, []);
    (0,react.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLocale(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Bene Bono | Cestas Ecol\xf3gicas y Anti Desperdicio"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Bene Bono"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "benebono.".concat(locale)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://img.plasmic.app/img-optimizer/v1/img/c44d43862fdbf580d7139ef62c2c6ffa.png?q=75&f=webp"
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                links: navigation.links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "recipes_container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: t("recipes.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "recipes_content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecipeSearchBar, {
                                setSearchTerm: setSearchTerm,
                                seasonTags: seasonTags,
                                dietTags: dietTags,
                                setSeasonFilter: setSeasonFilter,
                                setDietFilter: setDietFilter,
                                setShowFilters: setShowFilters,
                                showFilters: showFilters,
                                dietFilter: dietFilter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "recipes",
                                onClick: ()=>setShowFilters((prev)=>!prev),
                                children: recipes.data.map((r, i)=>{
                                    var _r_attributes_preview_image_data_, _r_attributes, _r_attributes_preview_image, _r_attributes_preview_image_data__attributes, _r_attributes_preview_image_data_1, _r_attributes1, _r_attributes_preview_image1, _r_attributes_preview_image_data__attributes1, _r_attributes_recipe_difficulty_data_, _r_attributes_recipe_difficulty, _r_attributes_recipe_difficulty_data__attributes;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/recipes/".concat(r.attributes.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipe, {
                                            imageUrl: ((_r_attributes_preview_image_data_ = (_r_attributes = r.attributes) === null || _r_attributes === void 0 ? void 0 : (_r_attributes_preview_image = _r_attributes.preview_image) === null || _r_attributes_preview_image === void 0 ? void 0 : _r_attributes_preview_image.data[0]) === null || _r_attributes_preview_image_data_ === void 0 ? void 0 : (_r_attributes_preview_image_data__attributes = _r_attributes_preview_image_data_.attributes) === null || _r_attributes_preview_image_data__attributes === void 0 ? void 0 : _r_attributes_preview_image_data__attributes.url) ? "".concat((_r_attributes_preview_image_data_1 = (_r_attributes1 = r.attributes) === null || _r_attributes1 === void 0 ? void 0 : (_r_attributes_preview_image1 = _r_attributes1.preview_image) === null || _r_attributes_preview_image1 === void 0 ? void 0 : _r_attributes_preview_image1.data[0]) === null || _r_attributes_preview_image_data_1 === void 0 ? void 0 : (_r_attributes_preview_image_data__attributes1 = _r_attributes_preview_image_data_1.attributes) === null || _r_attributes_preview_image_data__attributes1 === void 0 ? void 0 : _r_attributes_preview_image_data__attributes1.url) : "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
                                            tags: r.attributes.season_tags.data,
                                            title: r.attributes.title,
                                            difficulty: (_r_attributes_recipe_difficulty_data_ = (_r_attributes_recipe_difficulty = r === null || r === void 0 ? void 0 : r.attributes.recipe_difficulty) === null || _r_attributes_recipe_difficulty === void 0 ? void 0 : _r_attributes_recipe_difficulty.data[0]) === null || _r_attributes_recipe_difficulty_data_ === void 0 ? void 0 : (_r_attributes_recipe_difficulty_data__attributes = _r_attributes_recipe_difficulty_data_.attributes) === null || _r_attributes_recipe_difficulty_data__attributes === void 0 ? void 0 : _r_attributes_recipe_difficulty_data__attributes.name,
                                            duration: (r === null || r === void 0 ? void 0 : r.attributes.duration) < 60 ? "".concat(r === null || r === void 0 ? void 0 : r.attributes.duration, "min") : (0,helpers/* timeConvert */.V5)(r === null || r === void 0 ? void 0 : r.attributes.duration)
                                        })
                                    }, i);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        link: "/recipes",
                        pageCount: recipes.meta.pagination.pageCount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshedFooter/* default */.Z, {
                links: footer.links
            })
        ]
    });
}


/***/ }),

/***/ 905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "V5": function() { return /* binding */ timeConvert; },
/* harmony export */   "r_": function() { return /* binding */ printPrice; }
/* harmony export */ });
const printPrice = function() {
    let amountX100 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, currentSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "€", precision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    const formatPrice = "".concat((amountX100 / 100).toFixed(precision));
    const [euros, cents] = formatPrice.split(".");
    if (cents === "00") return "".concat(euros).concat(currentSymbol);
    return "".concat(formatPrice).concat(currentSymbol);
};
const debounce = (func, wait)=>{
    let timeout;
    return function executedFunction() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
const timeConvert = (n)=>{
    var hours = n / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + "h" + rminutes + "m";
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,193,774,888,179], function() { return __webpack_exec__(9254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);